import React from 'react';
import PropTypes from 'prop-types';

import get from 'lodash/get';
import { defineMessages, injectIntl } from 'react-intl';

import PercentageDataPod from '../../../components/PercentageDataPod';

const messages = defineMessages({
  title: {
    id: 'hubs.transfer.graduation-rate.title',
    defaultMessage: 'Transfer Graduation Rate',
  },
  tooltip: {
    id: 'hubs.transfer.graduation-rate.tooltip',
    defaultMessage: `This is the percentage of full-time non-first-time students receiving a bachelor's degree in 8 years.`,
  },
  tooltipHeader: {
    id: 'hubs.transfer.graduation-rate.tooltip-header',
    defaultMessage: 'What is Transfer Graduation Rate?',
  },
  text: {
    id: 'hubs.transfer.graduation-rate.text',
    defaultMessage: `For transfer students earning a bachelor's degree`,
  },
});

function TransferGraduationRate({ transferAdmissions, intl }) {
  const lastUpdated = get(transferAdmissions, 'lastUpdated.value');
  const graduationRate8 = get(transferAdmissions, 'graduationRate', {});

  return !Number.isNaN(+graduationRate8.value) && +graduationRate8.value > 0 ? (
    <PercentageDataPod
      header={intl.formatMessage(messages.title)}
      tooltip={intl.formatMessage(messages.tooltip)}
      tooltipHeader={intl.formatMessage(messages.tooltipHeader)}
      footer={lastUpdated}
      content={{
        values: [graduationRate8],
        text: intl.formatMessage(messages.text),
      }}
    />
  ) : null;
}

export default injectIntl(TransferGraduationRate);

TransferGraduationRate.propTypes = {
  intl: PropTypes.object,
  lastUpdated: PropTypes.string,
  transferAdmissions: PropTypes.object,
};
